import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useWritePromptPost = () => {
  const createWritePromptPostRequest = useCallback((payload) => {
    const { collectionId, legacyArticleLevelHeaderId, classroomIds, text } =
      payload;

    const body = {
      collection_id: collectionId,
      header_id: legacyArticleLevelHeaderId,
      text,
      classroom_ids: classroomIds,
    };

    const requestUrl = `${MONOLITH_ORIGIN}/api/v2/prompt/`;

    return new Request(requestUrl, {
      method: "POST",
      body: JSON.stringify(body),
      headers: { "Content-Type": "application/json" },
    });
  }, []);

  return useRestMutation(createWritePromptPostRequest);
};

export default useWritePromptPost;
